import { createSlice } from "@reduxjs/toolkit";
import { WaitersFilter, WaitersState } from "./types";
import dayjs from "dayjs";

const today =  dayjs().format("YYYY-MM-DD");
const oneWeekAge = dayjs().subtract(1, "week").format("YYYY-MM-DD");

export const defaultProductFilter: WaitersFilter = {
  Start: oneWeekAge,
  Finish: today,
};

export const initialState: WaitersState = {
  filter: defaultProductFilter,
};

const waitersSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setWaiertsFilter: (state, { payload }) => {
      state.filter = payload;
    },
  },
});

export const { setWaiertsFilter } = waitersSlice.actions;
export default waitersSlice.reducer;
